<template>
	<div class="app-background">
	<transition name="fade" type="transition" mode="in-out">
		<StageBackground
			v-for="stage in stages"
			:key="stage.name"
			:ref="'stages'"
			:settings="stage"
			v-if="isActiveStage(stage)"
		/>
	</transition>
	</div>
</template>

<script>
import StageBackground from '@/components/board/StageBackground';

export default {
	name: 'AppBackground',
	components: {
		StageBackground,
	},
	computed: {
		stages() {
			return this.$store.state.config.stages;
		},
	},
	methods: {
		isActiveStage(stage) {
			return this.$store.getters.currentStageSettings === stage;
		},
	},
};
</script>

<style lang="scss" scoped>
	.app-background {
		display: block;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 1;
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity 3s;
	}

	.fade-enter-active {
		z-index: 2;
	}

	.fade-leave-active {
		z-index: -1;
	}
</style>



// WEBPACK FOOTER //
// src/components/board/AppBackground.vue